import { Directive, Renderer2, ElementRef, HostListener, AfterContentChecked } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appMuAutosize]',
})
export class MuAutosizeDirective implements AfterContentChecked {
  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    /* */
  }

  ngAfterContentChecked(): void {
    this.setHeight();
  }

  @HostListener('input') logInputChange() {
    this.setHeight();
  }

  /**
   *    Set height of TextArea
   */
  setHeight(): void {
    const element = this.elementRef.nativeElement;
    if (element instanceof HTMLTextAreaElement) {
      this.renderer.setStyle(element, 'height', 'auto');
      this.renderer.setStyle(element, 'overflow', 'hidden');
      if (element.value !== '') {
        this.renderer.setStyle(element, 'height', `${element.scrollHeight}px`);
        return environment.guardClause;
      }

      this.renderer.setStyle(element, 'height', '33px');
    }
  }
}
